import React from "react";
import 'react-dates/initialize';
import ReactDOM from "react-dom";
import {BrowserRouter, Switch, Route, Redirect} from "react-router-dom";

import "assets/plugins/nucleo/css/nucleo.css";
import 'react-dates/lib/css/_datepicker.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import Clients from "./views/examples/Clients";
import {MetaTags} from "react-meta-tags";
import Business from "./views/Business/Business";
import Links from "./layouts/Links";
import Landing from "./layouts/Landing";

import "@fontsource/open-sans";

function renderMain(props) {
    return <AdminLayout {...props} />
}

ReactDOM.render(
<BrowserRouter>
    <MetaTags>
        <title>OPEN Manager</title>
        <meta property="og:type" content="website" />
        <meta property="og:description" content="Open Manager is a platform for gym and fitness studio managers and teachers. Manage your classes and resources, handle bookings and get insights on every aspect of your business." lang="en" />
        {/*<meta property="og:description" content="Open Manager es una plataforma para los gerentes de gimnasios y estudios de fitness son profesores. Gestiona tus clases y recursos, maneja las reservas y obtén información sobre cada aspecto de tu negocio." lang="es" />*/}
        {/*<meta property="og:description" content="OPEN предлагает вам современную, уникальную платформу для управления вашим бизнесом и заботится о том, чтобы у вас под рукой всегда было все необходимое для работы, в то время как у ваших клиентов есть свое приложение для общения с вами. Больше не нужно тратить время на телефонные звонки или непредвиденные отмены. OPEN дает вам контроль и понимание происходящего." lang="ru" />*/}
        {/*<meta property="og:title" content="Ваш партнер в вашем спортзале или студии" lang="ru"/>*/}
        <meta property="og:title" content="Gym and yoga studio Manager" lang="en"/>
        {/*<meta property="og:title" content="Gerente del gimnasio y estudio de yoga" lang="es"/>*/}
        <meta property="og:url" content="https://openmanagerapp.com" />
        <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/open-96133.appspot.com/o/open%2Fyoga-login-new.jpg?alt=media&token=68b61651-a5e5-49b5-8886-743e58ee3f37" />
        <meta property="og:locale:alternate" content="ru" />
        <meta property="og:locale:alternate" content="ru_RU" />
        <meta property="og:locale:alternate" content="es_ES" />
        <meta property="og:locale:alternate" content="es" />
    </MetaTags>
    <Switch>
        <Route path="/admin" render={props => <AdminLayout {...props} />}/>
        {/*<Route path="/teachers/all" render={props => <Teachers {...props} />}/>*/}
        <Route path="/links" render={props => <Links {...props} />}/>
        <Route path="/client/business" render={props => <Business {...props} />}/>
        <Route path="/auth" render={props => <AuthLayout {...props} />}/>
        <Route path="/admin/index" render={props => renderMain(props)}/>
        <Route path="/admin/index/clients" render={props => <Clients {...props} />}/>
        {/* eslint-disable-next-line react/jsx-no-undef */}
        <Route path="/welcome" render={props => <Landing {...props} />}/>
        <Redirect from="*" to="/admin/index"/>
        <Redirect from="/" to="/admin/index"/>
        <Route path="*" component={AdminLayout} />
        <Route path="*" render={props => <AdminLayout {...props} />}/>
        <Route path="/" render={props => <AdminLayout {...props} />} />
    </Switch>
</BrowserRouter>,
    document.getElementById("root")
);
